<template>
  <div
    id="gaiA"
    :class="{
      en: $i18n.locale === 'en-US',
    }"
  >
    <div
      id="gaiAModule1"
      :style="{ 'background-image': 'url(' + imageUrl1 + ')' }"
      v-lazy="imageUrl1"
    >
      <div id="gaiAModule1Text">
        <div id="gaiAModule1TextText1" class="gaiAModule1">
          {{ $t("productCenterGaiAView").h1 }}<sup class="sup">®</sup> 7
          {{ $t("productCenterGaiAView").h2 }}
        </div>
        <!-- <div id="gaiAModule1TextText2" class="gaiAModule1">
        </div> -->
        <div id="gaiAModule1TextText3" class="gaiAModule1">
          {{ $t("productCenterGaiAView").h3 }}
        </div>
      </div>
    </div>
    <div id="gaiAModule2">
      <div
        id="gaiAModule2Left"
        class="wow animate__animated animate__slideLeft"
      >
        <div id="gaiAModule2LeftText">
          <!-- <div id="gaiAModule2LeftTextText1" class="gaiAModule2">
            {{ $t("productCenterGaiAView").gaiAModule2[0] }}
          </div>
          <div id="gaiAModule2LeftTextText2" class="gaiAModule2">
            {{ $t("productCenterGaiAView").gaiAModule2[1] }}
          </div>
          <div id="gaiAModule2LeftTextText3" class="gaiAModule2">
            {{ $t("productCenterGaiAView").gaiAModule2[2] }}
          </div>
          <div id="gaiAModule2LeftTextText4" class="gaiAModule2">
            {{ $t("productCenterGaiAView").gaiAModule2[3] }}
          </div> -->
          <div
            id="gaiAModule2LeftTextText1"
            class="module-title pre-wrap"
            v-text="$t('productCenterGaiAView.gaiAModule2Title')"
          ></div>
          <div
            id="gaiAModule2LeftTextText3"
            class="module-subtitle pre-wrap"
            v-text="$t('productCenterGaiAView.gaiAModule2Subtitle')"
          ></div>
        </div>
      </div>
      <!-- 视频 -->
      <div
        id="gaiAModule2Right"
        class="wow animate__animated animate__fromRight"
      >
        <div id="gaiAModule2RightTop">
          <video
            ref="videoPlayer"
            controlsList="nodownload"
            src="@/static/img/gaiA1.mp4"
            muted
            autoplay
            loop
          ></video>
        </div>
        <div id="gaiAModule2RightBottom">
          <video
            ref="videoPlayer"
            controlsList="nodownload"
            src="@/static/img/gaiA2.mp4"
            muted
            autoplay
            loop
          ></video>
        </div>
      </div>
    </div>
    <div id="gaiAModule3">
      <div
        id="gaiAModule3Left"
        class="wow animate__animated animate__slideLeft"
        :style="{ 'background-image': 'url(' + imageUrl4 + ')' }"
        v-lazy="imageUrl4"
      ></div>
      <div id="gaiAModule3Right">
        <div
          id="gaiAModule3RightText"
          class="wow animate__animated animate__fromRight"
        >
          <!-- <div id="gaiAModule3RightTextText1" class="gaiAModule3">
            {{ $t("productCenterGaiAView").gaiAModule3[0] }}
          </div>
          <div id="gaiAModule3RightTextText2" class="gaiAModule3">
            {{ $t("productCenterGaiAView").gaiAModule3[1] }}
          </div>
          <div id="gaiAModule3RightTextText3" class="gaiAModule3">
            {{ $t("productCenterGaiAView").gaiAModule3[2] }}
          </div> -->
          <div
            class="module-title pre-wrap"
            v-text="$t('productCenterGaiAView.gaiAModule3Title')"
          ></div>
          <div
            class="module-subtitle pre-wrap"
            v-text="$t('productCenterGaiAView.gaiAModule3Subtitle')"
          ></div>
        </div>
      </div>
    </div>
    <div
      id="gaiAModule4"
      :style="{ 'background-image': 'url(' + imageUrl5 + ')' }"
      v-lazy="imageUrl5"
    >
      <div id="gaiAModule4Top">
        <div
          id="gaiAModule4TopText"
          class="module41 wow animate__animated animate__fadeInUp"
        >
          {{ $t("productCenterGaiAView").gaiAModule4.toolsMoudule }}
        </div>
      </div>
      <div id="gaiAModule4Bottom">
        <div id="gaiAModule4BottomCenter" class="module42">
          <div
            id="gaiAModule4BottomCenterContain"
            class="wow animate__animated animate__backDropFilterBlur"
          >
            <div id="gaiAModule4BottomCenterContainImg1">
              <img src="@/static/img/productmodule3icon4.png" alt="" />
            </div>
            <div id="gaiAModule4BottomCenterContainImg2">
              <img src="@/static/img/productmodule3icon1.png" alt="" />
            </div>
            <div class="feature-card-text">
              <div id="gaiAModule4BottomCenterContainText1">
                {{ $t("productCenterGaiAView").gaiAModule4.toolsMoudule1.h1 }}
              </div>
              <div id="gaiAModule4BottomCenterContainText2">
                {{ $t("productCenterGaiAView").gaiAModule4.toolsMoudule1.h2 }}
              </div>
            </div>
          </div>
          <div
            id="gaiAModule4BottomCenterContain"
            class="wow animate__animated animate__backDropFilterBlur"
          >
            <div id="gaiAModule4BottomCenterContainImg1">
              <img src="@/static/img/productmodule3icon5.png" alt="" />
            </div>
            <div id="gaiAModule4BottomCenterContainImg2">
              <img src="@/static/img/productmodule3icon2.png" alt="" />
            </div>
            <div class="feature-card-text">
              <div id="gaiAModule4BottomCenterContainText1">
                {{ $t("productCenterGaiAView").gaiAModule4.toolsMoudule2.h1 }}
              </div>
              <div id="gaiAModule4BottomCenterContainText2">
                {{ $t("productCenterGaiAView").gaiAModule4.toolsMoudule2.h2 }}
              </div>
            </div>
          </div>
          <div
            id="gaiAModule4BottomCenterContain"
            class="wow animate__animated animate__backDropFilterBlur"
          >
            <div id="gaiAModule4BottomCenterContainImg1">
              <img src="@/static/img/productmodule3icon6.png" alt="" />
            </div>
            <div id="gaiAModule4BottomCenterContainImg2">
              <img src="@/static/img/productmodule3icon3.png" alt="" />
            </div>
            <div class="feature-card-text">
              <div id="gaiAModule4BottomCenterContainText1">
                {{ $t("productCenterGaiAView").gaiAModule4.toolsMoudule3.h1 }}
              </div>
              <div id="gaiAModule4BottomCenterContainText2">
                {{ $t("productCenterGaiAView").gaiAModule4.toolsMoudule3.h2 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="gaiAModule5">
      <div id="gaiAModule5Left">
        <div
          id="gaiAModule5LeftText"
          class="module51 wow animate__animated animate__fadeInUp"
        >
          <div id="gaiAModule5LeftText1">SERVICE MODE</div>
          <div id="gaiAModule5LeftText2">
            {{ $t("productCenterGaiAView").gaiAModule5.serviceModel }}
          </div>
        </div>
      </div>
      <div id="gaiAModule5Right">
        <div id="gaiAModule5RightContent" class="module52">
          <div
            id="gaiAModule5RightContentContain"
            class="wow animate__animated animate__backDropFilterBlur"
          >
            <div id="gaiAModule5RightContentContain1Img1">
              <img src="@/static/img/productmodule5icon5icon1.png" alt="" />
            </div>
            <div id="gaiAModule5RightContentContain1Img2">
              <img src="@/static/img/productmodule5icon1.png" alt="" />
            </div>
            <div id="gaiAModule5RightContentContain1Text">
              <div id="gaiAModule5RightContentContain1TextText1">
                {{ $t("productCenterGaiAView").gaiAModule5.serviceModel1.h1 }}
              </div>
              <div id="gaiAModule5RightContentContain1TextText2">
                <div id="gaiAModule5RightContentContain1TextText2Dot">
                  <div
                    id="gaiAModule5RightContentContain1TextText2DotDOT"
                  ></div>
                </div>
                <div id="gaiAModule5RightContentContain1TextText2DotFont">
                  {{ $t("productCenterGaiAView").gaiAModule5.serviceModel1.h2 }}
                </div>
              </div>
              <div id="gaiAModule5RightContentContain1TextText3">
                <div id="gaiAModule5RightContentContain1TextText3Dot">
                  <div
                    id="gaiAModule5RightContentContain1TextText3DotDOT"
                  ></div>
                </div>
                <div id="gaiAModule5RightContentContain1TextText3DotFont">
                  {{ $t("productCenterGaiAView").gaiAModule5.serviceModel1.h3 }}
                </div>
              </div>
            </div>
          </div>
          <div
            id="gaiAModule5RightContentContain"
            class="wow animate__animated animate__backDropFilterBlur"
          >
            <div id="gaiAModule5RightContentContain1Img1">
              <img src="@/static/img/productmodule5icon5icon2.png" alt="" />
            </div>
            <div id="gaiAModule5RightContentContain1Img2">
              <img src="@/static/img/productmodule5icon2.png" alt="" />
            </div>
            <div id="gaiAModule5RightContentContain1Text">
              <div id="gaiAModule5RightContentContain1TextText1">
                {{ $t("productCenterGaiAView").gaiAModule5.serviceModel12.h1 }}
              </div>
              <div id="gaiAModule5RightContentContain1TextText2">
                <div id="gaiAModule5RightContentContain1TextText2Dot">
                  <div
                    id="gaiAModule5RightContentContain1TextText2DotDOT"
                  ></div>
                </div>
                <div id="gaiAModule5RightContentContain1TextText2DotFont">
                  {{
                    $t("productCenterGaiAView").gaiAModule5.serviceModel12.h2
                  }}
                </div>
              </div>
              <div id="gaiAModule5RightContentContain1TextText3">
                <div id="gaiAModule5RightContentContain1TextText3Dot">
                  <div
                    id="gaiAModule5RightContentContain1TextText3DotDOT"
                  ></div>
                </div>
                <div id="gaiAModule5RightContentContain1TextText3DotFont">
                  {{
                    $t("productCenterGaiAView").gaiAModule5.serviceModel12.h3
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="gaiAModule6">
      <div id="gaiAModule6Center">
        <div
          id="gaiAModule6Left"
          :style="{
            background: 'url(' + sassImg + ')  no-repeat center center',
          }"
          class="wow animate__animated animate__fadeInUp"
        ></div>
        <div id="gaiAModule6Right">
          <div
            id="gaiAModule6RightText"
            class="module62 wow animate__animated animate__fadeInUp"
          >
            <div id="gaiAModule6RightTextText1">FLOW DIAGRAM</div>
            <div id="gaiAModule6RightTextText2">
              {{ $t("productCenterGaiAView").gaiAModule6.sass }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="gaiAModuleFooter">
      <FooterComponents></FooterComponents>
    </div>
  </div>
</template>

<script>
import FooterComponents from "@/components/FooterComponents.vue";
import WOW from "wowjs";

export default {
  components: {
    FooterComponents,
  },
  data() {
    return {
      imageUrl1: require("@/static/img/productmodule4banner.png"),
      imageUrl4: require("@/static/img/productcoreechnology.gif"),
      imageUrl5: require("@/static/img/productmodule3bg.png"),
    };
  },
  computed: {
    sassImg() {
      return this.$t("productCenterGaiAView.gaiAModule6.sassImg");
    },
  },
  created() {
    const reloadOnOrientationChange = () => {
      const isLandscape = Math.abs(window.orientation) === 90;
      if (isLandscape) {
        location.reload();
      } else {
        location.reload();
      }
    };
    window.addEventListener("orientationchange", reloadOnOrientationChange);
  },
  mounted() {
    const wow = new WOW.WOW({
      live: false,
      // offset: 100
    });
    wow.init();

    const observerOptions = {
      rootMargin: "0px", // 边距
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("wow");
        } else {
          entry.target.classList.remove("wow");
        }
      });
    }, observerOptions);
    const elements = document.querySelectorAll(".wow");
    elements.forEach((el) => observer.observe(el));
  },
  methods: {},

  watch: {
    "$route.query.refresh": function () {
      window.location.reload();
    },
  },
};
</script>

<style scoped lang="scss">
//毛玻璃效果动画
:global(.animate__backDropFilterBlur) {
  animation-name: backDropFilterBlur;
}

@keyframes backDropFilterBlur {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

:global(.animate__backDropFilterBlur) {
  animation-duration: 1s !important;
}

#gaiA {
  width: 100%;
  // height: 100%;
  box-sizing: border-box;

  //左下到右上
  :global(.animate__slideLeft) {
    animation-name: zoomInLeft;
  }

  @keyframes zoomInLeft {
    from {
      opacity: 0;
      transform: translate(-50%, 50%) scale3d(0.3, 0.3, 0.3);
    }

    50% {
      opacity: 1;
    }

    to {
      opacity: 1;
      transform: none;
    }
  }

  :global(.animate__slideLeft) {
    animation-duration: 1s !important;
  }

  //右下到左上
  :global(.animate__fromRight) {
    animation-name: zoomInRight;
  }

  @keyframes zoomInRight {
    from {
      opacity: 0;
      transform: translate(50%, 50%) scale3d(0.3, 0.3, 0.3);
    }

    50% {
      opacity: 1;
    }

    to {
      opacity: 1;
      transform: none;
    }
  }

  :global(.animate__fromRight) {
    animation-duration: 1s !important;
  }

  @mixin whar($width, $height, $atio) {
    width: $width;
    height: $height;
    aspect-ratio: $atio;
    box-sizing: border-box;
  }

  @mixin bgar($atio) {
    text-align: center;
    margin-right: 1.5rem;
    aspect-ratio: $atio;
    background-size: cover;
  }

  @mixin display {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @mixin commitaspct {
    opacity: 1;
    width: 50%;
    aspect-ratio: 720/600;
    background-size: contain;
  }

  @mixin fontStyle(
    $fontweight,
    $height,
    $fontSize,
    $lineHeight,
    $letterSpaceing,
    $color
  ) {
    width: fit-content;
    font-weight: $fontweight;
    height: $height;
    font-size: $fontSize;
    font-style: normal;
    line-height: $lineHeight;
    letter-spacing: $letterSpaceing;
    color: $color;
  }

  @mixin gaiAModule4BottomCenterContain {
    width: 24rem;
    display: flex;
    height: 29rem;
    position: relative;
    border-radius: 0.25rem;
    flex-direction: column;
    backdrop-filter: blur(140px);
    box-shadow: 0px 1.5rem 2.5rem rgba(12, 12, 12, 0.4);
    background: linear-gradient(
      192.98deg,
      rgba(128, 186, 240, 0.1) 22.73%,
      rgba(16, 28, 60, 0.1) 72.38%
    );
  }

  .module-title {
    font-weight: 600;
    font-size: 1.5rem;
    line-height: 2.375rem;
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 1.25rem;
  }

  .module-subtitle {
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.625rem;
    color: rgba(255, 255, 255, 0.65);
  }

  #gaiAModule1 {
    background-size: cover;
    @include whar(100%, auto, 2880/960);
    padding: 12.9375rem 0rem 0rem 12.8125rem;

    .sup {
      font-weight: 400;
      font-size: 1rem;
      position: relative;
      top: -0.1875rem;
    }

    #gaiAModule1Text {
      width: fit-content;
      height: 7.75rem;
      line-height: 3.875rem;

      #gaiAModule1TextText1 {
        @include fontStyle(
          600,
          3.875rem,
          2.5rem,
          3.875rem,
          0.06944rem,
          rgba(255, 255, 255, 0.85)
        );
      }

      #gaiAModule1TextText2 {
        opacity: 1;
        @include fontStyle(
          600,
          3.875rem,
          2.5rem,
          3.875rem,
          0.06944rem,
          rgba(255, 255, 255, 0.85)
        );
      }

      #gaiAModule1TextText3 {
        opacity: 1;
        margin-top: 0.75rem;
        @include fontStyle(
          400,
          2rem,
          1.0625rem,
          2rem,
          0.06944rem,
          rgba(255, 255, 255, 0.65)
        );
      }
    }
  }

  #gaiAModule2 {
    width: 100%;
    display: flex;
    box-sizing: border-box;

    #gaiAModule2Left {
      width: 50%;
      @include display;

      #gaiAModule2LeftText {
        // margin: auto;
        // height: 9.5rem;
        // padding: 0 2rem;
        width: 28rem;

        #gaiAModule2LeftTextText1 {
          margin-bottom: 1.25rem;
          @include fontStyle(
            600,
            auto,
            1.5rem,
            2.375rem,
            0,
            rgba(255, 255, 255, 0.85)
          );
        }

        #gaiAModule2LeftTextText3,
        #gaiAModule2LeftTextText4 {
          @include fontStyle(
            400,
            1.625rem,
            0.875rem,
            1.625rem,
            0,
            rgba(255, 255, 255, 0.65)
          );
        }
      }
    }

    #gaiAModule2Right {
      width: 50%;
      display: flex;
      flex-direction: column;

      video {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }

      #gaiAModule2RightTop {
        aspect-ratio: 1440/514;
        background-size: contain;
      }

      #gaiAModule2RightBottom {
        aspect-ratio: 1440/686;
        background-size: contain;
      }
    }
  }

  #gaiAModule3 {
    width: 100%;
    display: flex;

    #gaiAModule3Left {
      left: 0rem;
      width: 50%;
      height: 100%;
      position: relative;
      aspect-ratio: 720/600;
      background-size: contain;
    }

    #gaiAModule3Right {
      width: 50%;
      @include display;

      #gaiAModule3RightText {
        // width: fit-content;
        width: 28rem;
        // padding: 0 2rem;

        #gaiAModule3RightTextText1 {
          margin-bottom: 1.25rem;
          @include fontStyle(
            600,
            2.375rem,
            1.5rem,
            2.375rem,
            0,
            rgba(255, 255, 255, 0.85)
          );
        }

        #gaiAModule3RightTextText2,
        #gaiAModule3RightTextText3 {
          @include fontStyle(
            400,
            1.62rem,
            0.875rem,
            1.625rem,
            0,
            rgba(255, 255, 255, 0.65)
          );
        }

        /* #gaiAModule3RightTextText3 {
          @include fontStyle(400, 1.62rem, .875rem, 1.625rem, 0, rgba(255, 255, 255, 0.65));
        } */
      }
    }
  }

  #gaiAModule4 {
    width: 100%;
    display: flex;
    flex-direction: column;
    aspect-ratio: 2880/1420;
    background-size: cover;

    #gaiAModule4Top {
      width: 100%;
      height: 30%;
      @include display;

      #gaiAModule4TopText {
        opacity: 1;
        top: -0.5rem;
        position: relative;
        text-align: center;
        @include fontStyle(
          600,
          3.125rem,
          2.25rem,
          6.125rem,
          0,
          rgba(255, 255, 255, 0.85)
        );
      }
    }

    #gaiAModule4Bottom {
      width: 100%;
      height: 70%;

      #gaiAModule4BottomCenter {
        opacity: 1;
        width: 82%;
        height: 80%;
        margin: auto;
        bottom: 1rem;
        display: flex;
        position: relative;
        justify-content: space-evenly;

        #gaiAModule4BottomCenterContain {
          @include gaiAModule4BottomCenterContain;

          #gaiAModule4BottomCenterContainImg1 {
            top: 0;
            right: 0;
            opacity: 1;
            width: 12.1906rem;
            position: absolute;
            height: 11.1225rem;

            img {
              width: 100%;
            }
          }

          #gaiAModule4BottomCenterContainImg2 {
            top: 8.8125rem;
            left: 3.0625rem;
            width: 4.375rem;
            height: 4.375rem;
            position: absolute;

            img {
              width: 100%;
            }
          }

          .feature-card-text {
            left: 3.5rem;
            margin: auto;
            top: 14.65rem;
            position: absolute;
          }

          #gaiAModule4BottomCenterContainText1 {
            // left: 3.5rem;
            // margin: auto;
            // top: 14.65rem;
            // position: absolute;
            margin-bottom: 1.25rem;
            @include fontStyle(
              500,
              // 2.25rem,
              auto,
              1.6rem,
              2.25rem,
              0,
              rgba(255, 255, 255, 0.85)
            );
          }

          #gaiAModule4BottomCenterContainText2 {
            // left: 3.6rem;
            // position: absolute;
            // top: 18.15rem !important;
            @include fontStyle(
              400,
              7.875rem,
              0.875rem,
              1.7rem,
              0,
              rgba(255, 255, 255, 0.65)
            );
            width: 17rem;
          }
        }
      }
    }
  }

  #gaiAModule5 {
    width: 100%;
    display: flex;
    background: url("@/static/img/productmodule5bg.png") no-repeat 100% 100%;
    background-size: cover;
    aspect-ratio: 2880/1200;
    position: relative;

    #gaiAModule5Left {
      width: 30%;
      height: 100%;
      position: relative;

      #gaiAModule5LeftText {
        display: flex;
        position: absolute;
        flex-direction: column;
        top: 12rem;
        left: 16rem;
        position: relative;
        opacity: 1;

        #gaiAModule5LeftText1 {
          color: rgba(255, 255, 255, 0.2);
          font-weight: 300;
          width: fit-content;
          font-size: 2.5rem;
          height: 3.3125rem;
          font-style: normal;
          letter-spacing: 1px;

          line-height: 2.9375rem;
          text-transform: uppercase;
          color: rgba(255, 255, 255, 0.2);
        }

        #gaiAModule5LeftText2 {
          height: 3.625rem;
          font-weight: 600;
          line-height: 160%;
          width: fit-content;
          padding-top: 100px;
          font-style: normal;
          font-size: 2.5rem;
          letter-spacing: 0.02em;

          color: rgba(255, 255, 255, 0.85);
        }
      }
    }

    #gaiAModule5Right {
      width: 62%;
      position: absolute;
      top: 42%;
      left: 70%;
      margin-left: -32.5%;
      margin-top: -11.875rem;

      #gaiAModule5RightContent {
        width: 80%;
        display: flex;
        margin-left: 7rem;
        justify-content: space-evenly;

        #gaiAModule5RightContentContain {
          box-shadow: 0px 1.5rem 2.5rem rgba(12, 12, 12, 0.4);
          backdrop-filter: blur(140px);
          border-radius: 0.25rem;
          background: linear-gradient(
            192.98deg,
            rgba(128, 186, 240, 0.1) 22.73%,
            rgba(16, 28, 60, 0.1) 72.38%
          );
          width: 22rem;
          box-sizing: border-box;
          padding: 20rem 0.1rem 7rem 0.1rem;

          #gaiAModule5RightContentContain1Img1 {
            width: 48%;
            height: 48%;
            margin-top: -20rem;
            margin-left: 11.4rem;

            img {
              width: 100%;
            }
          }

          #gaiAModule5RightContentContain1Img2 {
            width: 4rem;
            height: 5rem;
            margin-top: 9rem;
            margin-left: 1.85rem;

            img {
              width: 100%;
            }
          }

          #gaiAModule5RightContentContain1Text {
            left: 10%;
            width: 80%;
            margin: auto;
            position: absolute;

            #gaiAModule5RightContentContain1TextText1 {
              font-weight: 500;
              font-size: 1.5rem;
              font-style: normal;
              line-height: 2.25rem;
              margin-bottom: 1.25rem;
              letter-spacing: 0.2rem;

              color: rgba(255, 255, 255, 0.85);
            }

            #gaiAModule5RightContentContain1TextText2 {
              display: flex;
              width: fit-content;
              font-style: normal;
              color: rgba(255, 255, 255, 0.65);
              margin-bottom: 0.75rem;

              #gaiAModule5RightContentContain1TextText2Dot {
                width: 0.4rem;
                height: 1.225rem;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: center;

                #gaiAModule5RightContentContain1TextText2DotDOT {
                  width: 0.4rem;
                  height: 0.4rem;
                  border-radius: 0.2rem;
                  background-color: red;
                }
              }

              #gaiAModule5RightContentContain1TextText2DotFont {
                box-sizing: border-box;
                padding: 0rem 0.2rem 0rem 0.8rem;
                font-size: 0.875rem;

                color: rgba(255, 255, 255, 0.65);
              }
            }

            #gaiAModule5RightContentContain1TextText3 {
              margin-top: 0.5rem;
              display: flex;
              width: fit-content;

              font-style: normal;
              color: rgba(255, 255, 255, 0.65);

              #gaiAModule5RightContentContain1TextText3Dot {
                width: 0.4rem;
                height: 1.225rem;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: center;

                #gaiAModule5RightContentContain1TextText3DotDOT {
                  width: 0.4rem;
                  height: 0.4rem;
                  border-radius: 0.2rem;
                  background-color: red;
                }
              }

              #gaiAModule5RightContentContain1TextText3DotFont {
                box-sizing: border-box;
                padding: 0rem 0.2rem 0.5rem 0.8rem;
                color: rgba(255, 255, 255, 0.65);
                font-size: 0.875rem;
              }
            }
          }
        }
      }
    }
  }

  #gaiAModule6 {
    width: 100%;
    height: 40rem;
    display: flex;
    justify-content: center;
    align-items: center;

    #gaiAModule6Center {
      display: flex;
      aspect-ratio: 1440/640;

      #gaiAModule6Left {
        width: 41rem;
        height: 33.25rem;
        // background: url("@/static/img/productmodule6.png") no-repeat center
        // center;
        background-size: cover !important;
      }

      #gaiAModule6Right {
        margin-left: 3.75rem;
        box-sizing: border-box;
        // padding-top: 4.8rem;
        padding-top: 9.8rem;

        #gaiAModule6RightText {
          // width: 16rem;
          width: auto;
          height: 7.6875rem;

          #gaiAModule6RightTextText1 {
            @include fontStyle(
              300,
              3.3125rem,
              2.2rem,
              3.3125rem,
              0.0625rem,
              rgba(255, 255, 255, 0.2)
            );
            width: 16rem;
            white-space: nowrap;
          }

          #gaiAModule6RightTextText2 {
            margin-top: 0.75rem;
            @include fontStyle(
              600,
              3.625rem,
              2.2rem,
              3.625rem,
              0.02em,
              rgba(255, 255, 255, 0.85)
            );
          }
        }
      }
    }
  }

  #gaiAModuleFooter {
    width: 100%;
    height: 18rem;
  }

  &.en {
    .module-title,
    .module-subtitle,
    #gaiAModule4BottomCenterContainText1,
    #gaiAModule4BottomCenterContainText2,
    #gaiAModule5RightContentContain1TextText2DotFont,
    #gaiAModule5RightContentContain1TextText3DotFont,
    #gaiAModule6RightTextText2 {
      line-height: 1.5 !important;
    }
    // .module-subtitle,
    // #gaiAModule4BottomCenterContainText2,
    // #gaiAModule5RightContentContain1TextText2DotFont,
    // #gaiAModule5RightContentContain1TextText3DotFont {
    //   text-align: justify !important;
    // }
    .feature-card-text div:first-child,
    #gaiAModule5RightContentContain1TextText1 {
      height: 3rem !important;
      font-size: 1.2rem !important;
      font-weight: bold !important;
    }
  }
}
</style>
